import { http } from "./client";
import type { LoginResult } from "./auth";

// "Login with Key" - a second, key-based front door to the same Super Admin
// session password login opens (see lib/api/auth.ts's authApi.login).
// Unauthenticated - the key itself is the credential, the same convention
// as platformAdminsApi.redeemActivation.
export interface KeyLoginPayload {
  key: string;
  // Required whenever the account (or the key itself) requires
  // multi-factor authentication - see LoginPayload.mfa_code for the
  // identical contract on password login.
  mfa_code?: string;
}

export const superAdminAuthApi = {
  keyLogin: (payload: KeyLoginPayload) => http.post<LoginResult>("/super-admin/auth/key-login", payload),
};
